<template>
  <div class="section break-page" style="page-break-inside:avoid">
    <div class="container">
      <div class="columns">
        <div class="column">
          <div class="title is-1">
            Consent:
          </div>
          <div v-if="$store.getters.isAdmin">
            <div v-if="consents.length > 0">
              <b-table :data="consents"
                       :hoverable="true"
                       :loading="isLoading"
                       :mobile-cards="true"
                       :paginated="true"
                       :per-page="10"
                       :pagination-simple="true">
                <b-table-column field="Answer" label="Answer" sortable v-slot="props">
                  {{ props.row.Answer }}
                </b-table-column>
                <b-table-column field="Name" label="Name" sortable v-slot="props">
                  {{ props.row.Name }}
                </b-table-column>
                <b-table-column field="Organization" label="Organization" sortable v-slot="props">
                  {{ props.row.Organization }}
                </b-table-column>
                <b-table-column field="Email" label="Email" sortable v-slot="props">
                  {{ props.row.Email }}
                </b-table-column>
              </b-table>
            </div>
            <div v-if="consents.length < 1">
              <p>No users have sumbitted their answers for the consent to publicly credit their firm.</p>
            </div>
          </div>
          <div v-if="!$store.getters.isAdmin">
            <p>Consent for AWG to publicly credit your firm as a contributing firm in {{ $store.getters["currentQuestionnaire"].CountryName }}.</p>
            <p>AWG thanks you for your diligent and valuable assistance in completing this questionnaire. Your contribution to the Index is very much appreciated, and AWG would like to acknowledge your participation by publicly crediting your involvement with this project, subject to your consent (please indicate below).</p>
            <div class="field">
              <b-radio v-model="consent" native-value="Yes">YES, I consent to AWG publicly crediting my organization as a contributing firm to the Index</b-radio>
            </div>
            <div class="field">
              <b-radio v-model="consent" native-value="No">NO, please do not publicly credit my organization as a contributing firm to the Index.</b-radio>
            </div>
          </div>
          <p class="breathe"></p>
          <div v-if="IsClosed && !exporting">
            <div class="level-left">
              <div class="level-item">
                <b-button class="button is-primary" @click="$router.push('/questionnaire/disclaimer')">Back</b-button>
              </div>
              <div class="level-item">
                <b-button class="button is-primary" @click="$router.push('/questionnaire/a/0')">Next</b-button>
              </div>
            </div>
          </div>
          <div v-if="!IsClosed && !exporting" class="level">
            <div class="level-left">
              <div class="level-item">
                <b-button class="button is-primary" @click="goToPreviousPage">Save and Back</b-button>
              </div>
              <div class="level-item">
                <b-button class="button is-primary" @click="goToNextPage">Save and Next</b-button>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-button class="button is-primary" @click="save">Save</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import sections from "@/enums/sections.ts";
  export default {
    data() {
      return {
        consent: "",
        consents: [],
        isLoading: false,
        qpromise: new Promise((resolve, reject) => { })
      }
    },
    props: {
      exporting: Boolean
    },
    computed: {
      IsClosed() {
        if (this.exporting)
          return this.$parent.options.Status == "Closed";
        else
          return this.$store.getters.currentQuestionnaire.Status == "Closed";
      }
    },
    methods: {
      async Unlock() {
        await this.$http.get("api/questionnaire/unlock");
        window.addEventListener("beforeunload", this.Unlock);
        return null;
      },
      goToPreviousPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/participation');
        });
      },
      goToNextPage() {
        this.save().then(() => {
          this.$router.push('/questionnaire/a/0');
        });
      },
      async save() {
        await this.$http.post("api/consent", { QuestionnaireId: this.$store.getters["currentQuestionnaire"].Id, UserId: this.$store.getters.user.Id, Answer: this.consent })
          .then(resp => {
            this.$buefy.notification.open(resp.data);
          }).catch(err => {
            console.error(err);
          });
      }
    },
    async created() {
      var Id = -1;
      if (this.exporting) {
        Id = this.$parent.options.Id;
      }
      else {
        Id = this.$store.getters.currentQuestionnaire.Id;
      }

      if (this.$store.getters.isAdmin) {
        this.isLoading = true;
        this.qpromise = this.$http.get("api/consent/" + Id)
          .then(resp => {
            this.consents = resp.data;
            this.isLoading = false;
          }).catch(e => {
            this.isLoading = false;
            console.error(e);
          })
      } else {
        this.qpromise = this.$http.post("api/consent/answer", { QuestionnaireId: Id, UserId: this.$store.getters.user.Id })
          .then(resp => {
            if (resp.data != "No Answer") {
              this.consent = resp.data;
            }
          }).catch(e => {
            console.error(e);
          })
      }

      if (!this.exporting)
        window.addEventListener("beforeunload", this.Unlock);
    },
    mounted() {
      this.qpromise.then(r => {
        this.$store.getters.bus.$emit('loaded', { exporting: this.exporting });
      });
    },
    beforeDestroy() {
      if (!this.exporting)
        this.Unlock();
    }
  }
</script>

<style>

  .intro-input {
    margin-bottom: 5px;
  }
</style>
